import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Avatar from "@material-ui/core/Avatar";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import { Typography } from "@material-ui/core";
import Colors from "../../constants/Colors";
import Grow from "@material-ui/core/Grow";
import GradeIcon from "@material-ui/icons/Grade";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

moment.locale("fr");

const displayDate = date => {
  const current = moment().startOf("day");
  // const today = moment();
  const doneDate = moment(date);
  // const doneDate = moment(date);
  const hour = doneDate.format("HH:mm");
  const lastDate = doneDate.startOf("day");
  const diff = current.diff(lastDate, "days");
  if (diff === 0) {
    return i18n.t("today");
  } else if (diff === 1) {
    return i18n.t("yesterday");
  }
  return i18n.t("ago", { days: diff });
  // return `- Il y a ${diff} jours à ${doneDate.format('HH:mm')}`;
};

const styles = theme => ({
  main: {
    width: "20%",
    minWidth: 100,
    // maxWidth: "20%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  root: {
    // width: "100%",
    width: 150,
    minWidth: 150,
    height: 250,
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper
  },
  bold: {
    fontWeight: 500,
    marginBottom: 10
  },
  box: {
    webkitBoxShadow: "0px 0px 4px 1px #D8D8D8",
    mozBoxShadow: "0px 0px 4px 1px #D8D8D8",
    boxShadow: "0px 0px 4px 1px #D8D8D8",
    flex: 1,
    paddingLeft: 8,
    paddingRight: 8,
    paddingBottom: 15,
    flexDirection: "column",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  rating: {
    color: Colors.main,
    marginTop: 10,
    fontWeight: 500
  },
  category: {
    color: "#fff",
    fontWeight: 500
    // marginBottom: 10,
  },
  categoryBox: {
    borderRadius: 15,
    padding: "1px 8px",
    marginBottom: 10
  },
  actionText: {
    // fontFamily: [
    //   "-apple-system",
    //   "BlinkMacSystemFont",
    //   '"Segoe UI"',
    //   "Roboto",
    //   '"Helvetica Neue"',
    //   "Arial",
    //   "sans-serif",
    //   '"Apple Color Emoji"',
    //   '"Segoe UI Emoji"',
    //   '"Segoe UI Symbol"'
    // ].join(","),
    color: Colors.text,
    textAlign: "center"
  },
  doneText: {
    fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"].join(","),
    color: Colors.text,
    textAlign: "center",
    lineHeight: 1.5,
    letterSpacing: "0.01071em",
    fontWeight: 500
    // marginTop: 10
  },
  ratingDiv: {
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "center",
    display: "flex"
  }
});

const getColor = donePercent => {
  if (donePercent <= 25) {
    return "red";
  } else if (donePercent >= 75) {
    return Colors.green;
  }
};

const BestAction = ({
  title,
  category,
  count,
  color,
  classes,
  isManager,
  donePercentage,
  rating,
  date,
  isFake
}) => {
  const { t, i18n } = useTranslation();
  return (
    <div className={classes.main}>
      <div style={{ backgroundColor: color }} className={classes.categoryBox}>
        <Typography classes={{ root: classes.category }} align="center">
          {t(category)}
        </Typography>
      </div>
      <Grow in>
        <Paper className={classes.box}>
          <div className={classes.root}>
            <p
              className={classes.actionText}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </div>
        </Paper>
      </Grow>
      {isManager && (
        <p
          // style={{ color: getColor(donePercent) }}
          className={classes.doneText}
        >
          Fait à{" "}
          <span style={{ color: getColor(donePercentage), fontWeight: "bold" }}>
            {count && !isFake
              ? (donePercentage / count).toFixed(2)
              : donePercentage || 0}{" "}
            %
          </span>
        </p>
      )}
      <div className={classes.ratingDiv}>
        <GradeIcon color="primary" style={{ color: Colors.yellow }} />
        <Typography
          classes={{ root: classes.rating }}
          style={{ color: Colors.text, marginLeft: 5, marginTop: 2 }}
        >
          {count && !isFake ? (rating / count).toFixed(2) : rating || 0}
        </Typography>
      </div>
      {!isManager && (
        <Typography
          style={{ color: Colors.text }}
          classes={{ root: classes.rating }}
          align="center"
        >
          Fait à{" "}
          <span style={{ color: getColor(donePercentage), fontWeight: "bold" }}>
            {count && !isFake
              ? (donePercentage / count).toFixed(2)
              : donePercentage || 0}{" "}
            %
          </span>
        </Typography>
        // <p
        //   // style={{ color: getColor(donePercent) }}
        //   className={classes.doneText}
        // >
        //   Fait à{" "}
        //   <span style={{ color: getColor(donePercentage), fontWeight: "bold" }}>
        //     {(donePercentage / count).toFixed(2)} %
        //   </span>
        // </p>
      )}

      {!isManager && (
        <Typography
          style={{ color }}
          classes={{ root: classes.rating }}
          align="center"
        >
          {`Fait ${count} fois`}
        </Typography>
      )}
      {isManager && (
        <Typography
          style={{ color }}
          classes={{ root: classes.rating }}
          align="center"
        >
          {`Fait ${displayDate(date)}`}
        </Typography>
      )}
    </div>
  );
};

export default withStyles(styles)(BestAction);
